export const getDatePlusYear = () => new Date(Date.now() + 1000 * 60 * 60 * 24 * 365);
export const getDatePlusWeek = () => new Date(Date.now() + 1000 * 60 * 60 * 24 * 7);
